import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import './StudyMissionLoading.css';

export function StudyMissionLoading() {
  const { missionId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('PENDING');
  const [message, setMessage] = useState('Aguardando processamento...');
  const [error, setError] = useState(null);
  const [elapsed, setElapsed] = useState(0);
  const [estimatedRemaining, setEstimatedRemaining] = useState(120);

  useEffect(() => {
    let pollInterval;
    let timerInterval;
    
    const pollStatus = async () => {
      try {
        const response = await api.get(`/study-missions/${missionId}/status`);
        const { 
          processing_status, 
          message: statusMessage,
          error: errorMsg,
          elapsed_seconds,
          estimated_remaining
        } = response.data;
        
        setStatus(processing_status);
        setMessage(statusMessage);
        
        if (elapsed_seconds !== undefined) {
          setElapsed(elapsed_seconds);
        }
        
        if (estimated_remaining !== undefined) {
          setEstimatedRemaining(estimated_remaining);
        }
        
        if (processing_status === 'COMPLETED') {
          // Sucesso! Redireciona para o dashboard do responsável
          clearInterval(pollInterval);
          clearInterval(timerInterval);
          
          setTimeout(() => {
            navigate('/parent-dashboard', { 
              state: { 
                message: 'Missão de Estudo criada com sucesso!',
                missionId: missionId 
              } 
            });
          }, 1000);
          
        } else if (processing_status === 'FAILED') {
          // Erro no processamento
          setError(errorMsg);
          clearInterval(pollInterval);
          clearInterval(timerInterval);
        }
        
      } catch (err) {
        console.error('Erro ao consultar status:', err);
        // Continua tentando se for erro de rede temporário
      }
    };
    
    // Primeira verificação imediata
    pollStatus();
    
    // Poll a cada 3 segundos
    pollInterval = setInterval(pollStatus, 3000);
    
    // Timer visual (independente do backend)
    timerInterval = setInterval(() => {
      setElapsed(prev => prev + 1);
    }, 1000);
    
    // Cleanup ao desmontar componente
    return () => {
      clearInterval(pollInterval);
      clearInterval(timerInterval);
    };
  }, [missionId, navigate]);

  if (error) {
    return (
      <div className="loading-container error">
        <div className="error-icon">❌</div>
        <h2>Erro ao criar missão</h2>
        <p className="error-message">{error}</p>
        <button 
          className="btn-retry"
          onClick={() => navigate('/parent/study-missions/new')}
        >
          Tentar Novamente
        </button>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <div className="spinner"></div>
      
      <h2>🤖 Gerando sua Missão de Estudo...</h2>
      <p className="status-message">{message}</p>
      
      <div className="progress-container">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ 
              width: `${Math.min((elapsed / 120) * 100, 100)}%` 
            }}
          ></div>
        </div>
        
        <div className="time-info">
          <span className="elapsed-time">
            ⏱️ {elapsed}s decorridos
          </span>
          {estimatedRemaining > 0 && (
            <span className="remaining-time">
              ⏳ ~{estimatedRemaining}s restantes
            </span>
          )}
        </div>
      </div>
      
      <div className="loading-steps">
        <div className={`loading-step ${elapsed > 5 ? 'completed' : 'active'}`}>
          📄 Processando conteúdo
        </div>
        <div className={`loading-step ${elapsed > 20 ? 'completed' : elapsed > 5 ? 'active' : ''}`}>
          📝 Gerando resumo educacional
        </div>
        <div className={`loading-step ${elapsed > 40 ? 'completed' : elapsed > 20 ? 'active' : ''}`}>
          🎯 Criando atividades interativas
        </div>
        <div className={`loading-step ${status === 'COMPLETED' ? 'completed' : elapsed > 40 ? 'active' : ''}`}>
          ✅ Finalizando missão
        </div>
      </div>
      
      <small className="hint">
        Aguarde enquanto a IA cria conteúdo educacional personalizado
      </small>
    </div>
  );
}
